module.exports = kolibriGlobal.urls;